import React from 'react';
import theme from '../theme';

export function IconMenu() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
}

function SideMenu({ open, onClose, items, onLogout }) {
  return (
    <>
      {open && (
        <div
          onClick={onClose}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.4)', zIndex: 1050,
          }}
        />
      )}
      <div style={{
        position: 'fixed', top: 0, right: 0, bottom: 0,
        width: '78%', maxWidth: 320,
        background: theme.colors.white,
        boxShadow: theme.shadow.floating,
        zIndex: 1051,
        transform: open ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 0.25s ease',
        display: 'flex', flexDirection: 'column',
        paddingTop: 'env(safe-area-inset-top, 0px)',
      }}>
        <div style={{
          padding: '20px 20px 14px', borderBottom: `1px solid ${theme.colors.border}`,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <span style={{ fontWeight: 700, fontSize: theme.font.size.xl, color: theme.colors.textPrimary }}>Menu</span>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: theme.colors.textMuted, padding: 0,
          }}>✕</button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: theme.spacing.md }}>
          {items.map((item, i) => (
            <button
              key={i}
              onClick={item.disabled ? undefined : item.onClick}
              disabled={item.disabled}
              style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: theme.spacing.md,
                padding: '14px 12px', background: 'none', border: 'none',
                borderRadius: theme.radius.md, cursor: item.disabled ? 'default' : 'pointer',
                fontSize: theme.font.size.md, textAlign: 'left',
                color: item.disabled ? theme.colors.textMuted : theme.colors.textPrimary,
                opacity: item.disabled ? 0.6 : 1,
              }}>
              <span style={{ fontSize: 20, flexShrink: 0 }}>{item.emoji}</span>
              <span style={{ flex: 1 }}>{item.label}</span>
              {item.disabled && (
                <span style={{
                  fontSize: theme.font.size.xs, color: theme.colors.textMuted,
                  background: theme.colors.backgroundAlt, padding: '2px 8px', borderRadius: theme.radius.pill,
                }}>Prossimamente</span>
              )}
            </button>
          ))}
        </div>

        <div style={{ padding: theme.spacing.md, borderTop: `1px solid ${theme.colors.border}` }}>
          <button onClick={onLogout} style={{
            width: '100%', display: 'flex', alignItems: 'center', gap: theme.spacing.md,
            padding: '14px 12px', background: 'none', border: 'none',
            borderRadius: theme.radius.md, cursor: 'pointer',
            fontSize: theme.font.size.md, textAlign: 'left', color: theme.colors.error,
          }}>
            <span style={{ fontSize: 20, flexShrink: 0 }}>🚪</span>
            <span>Esci</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default SideMenu;